(function () {
    'use strict';
    const Cookies = require('js-cookie');
    var localeDisplayNames = require('../constants/LocaleDisplayNames');
    var Constants = require('../constants/AppConstants');
    var LocaleUtils = require('./localeUtils');
    var defaultMessages = require('../i18n/messages/default');
    var _ = require('lodash');
    var TagManager = require('react-gtm-module');
    var base64url = require('base64url');
    var OAuthClientConfig = require('../LPAuthUtils/OAuthClientConfig');
    var { Session } = require('../LPAuthUtils/SessionMonitor.js');
    var { clearLocalStorage, generateLogoutUrl } = require('../LPAuthUtils/AuthUtil');
    const UrlUtils = require('./urlUtils');
    const { decodeJwt } = require("jose");

    var Utils = {
        addHtlmLangAttribute: function (langAttribute) {
            const htmlElement = document.getElementsByTagName('html');
            htmlElement[0].setAttribute('lang', langAttribute);
        },

        mapLocaleData: function (supportedLocales) {
            let supportedLocaleMap = [];
            supportedLocales.forEach(function (locale) {
                supportedLocaleMap.push({ "locale": locale, "displayName": localeDisplayNames[locale.toLowerCase()] });
            }, this);
            return supportedLocaleMap;
        },

        isFirstMethodOtp : function (methodsArray){
            if(!methodsArray || methodsArray.length === 0){
              return
            }
        
            if(methodsArray[0].method === "otp"){
              return true;
            }else{
              return false
            }
        },

        loadQualtrics: function (percentNumber, viewType, eventType="load") {
            var g = function (e, h, f, g) {
                this.get = function (a) { for (var a = a + "=", c = document.cookie.split(";"), b = 0, e = c.length; b < e; b++) { for (var d = c[b]; " " == d.charAt(0);)d = d.substring(1, d.length); if (0 == d.indexOf(a)) return d.substring(a.length, d.length) } return null };
                this.set = function (a, c) { var b = "", b = new Date; b.setTime(b.getTime() + 6048E5); b = "; expires=" + b.toGMTString(); document.cookie = a + "=" + c + b + "; path=/; " };
                this.check = function () { var a = this.get(f); if (a) a = a.split(":"); else if (100 != e) "v" == h && (e = Math.random() >= e / 100 ? 0 : 100), a = [h, e, 0], this.set(f, a.join(":")); else return !0; var c = a[1]; if (100 == c) return !0; switch (a[0]) { case "v": return !1; case "r": return c = a[2] % Math.floor(100 / c), a[2]++, this.set(f, a.join(":")), !c }return !0 };
                this.go = function () { if (this.check()) { var a = document.createElement("script"); a.type = "text/javascript"; a.src = g; document.body && document.body.appendChild(a) } };
                this.start = function () { 
                    var t = this;
                    if(eventType === "load"){
                        "complete" !== document.readyState ? window.addEventListener ? window.addEventListener("load", function () { t.go() }, !1) : window.attachEvent && window.attachEvent("onload", function () { t.go() }) : t.go() 
                    }else{
                        t.go();
                    }
                };
            };
            try { (new g(percentNumber, viewType, "QSI_S_ZN_86teTLpjbZZ8hz7", "https://zn86tetlpjbzz8hz7-metro.siteintercept.qualtrics.com/SIE/?Q_ZID=ZN_86teTLpjbZZ8hz7")).start() } catch (i) { }
        },

        createNoscriptAndIframeElement: function (iframeSrc) {
            const noscript = document.createElement('noscript');

            const iframe = document.createElement('iframe');
            iframe.src = iframeSrc
            iframe.height = "0";
            iframe.width = "0";
            iframe.style = "display:none;visibility:hidden"
            try {
                const noscriptElement = document.querySelector('noscript');
                if (noscriptElement) {
                    noscriptElement.appendChild(iframe)
                }
                else {
                    noscript.appendChild(iframe);
                    document.querySelector("body").appendChild(noscript);
                }
            }
            catch (e) {
                console.warn("There is a problem initiating GA4 script: ", e)
            }
        },

        loadGA4Production: function () {
            this.createNoscriptAndIframeElement("https://www.googletagmanager.com/ns.html?id=GTM-WV3QJWR")
        },

        loadGA4PreProduction: function () {
            this.createNoscriptAndIframeElement("https://www.googletagmanager.com/ns.html?id=GTM-WV3QJWR&gtm_auth=FD1NkpkcCqx8ibM75KC7OA&gtm_preview=env-12&gtm_cookies_win=x")
        },

        loadGA4Development: function () {
            this.createNoscriptAndIframeElement("https://www.googletagmanager.com/ns.html?id=GTM-WV3QJWR&gtm_auth=KFocfiRJsXRMVlXxiiiZNA&gtm_preview=env-209&gtm_cookies_win=x")
        },

        loadGA4BasedOnEnv: function (env) {
            switch (env) {
                case 'prod':
                    this.loadGA4Production();
                    break;
                case 'pp':
                    this.loadGA4PreProduction();
                    break;
                default:
                    this.loadGA4Development();
                    break;
            }
        },

        loadCookieScripts: function (countryCode) {
            const host = Constants.CookieDomains[
                window.WebConstants.stage === 'prod'? 'prod' : 'dev'
            ][countryCode];

            let allowedCookies = Cookies.get('allowedCookieCategories') || "performance";
            if (host) {
                let script = document.createElement('script');
                script.onload = function () {
                    let el = document.createElement("cms-cookie-disclaimer");
                    document.querySelector("body").appendChild(el);
                };
                script.src = `https://${host}/data/apps/metro?sc_device=webcomponent&components=cookie%20disclaimer`;
                document.head.appendChild(script);
            }

            if(allowedCookies.includes('performance')) {
                // Load the GA4 script
                this.loadGA4BasedOnEnv(window.WebConstants.stage);
                if(UrlUtils.getParameterByName("passwordless") !== "true"){
                    Utils.loadQualtrics(2,"v");
                }
            }
        },

        removeCookies:function (){
            let allowedCookies = Cookies.get('allowedCookieCategories') || "performance";
            const includesPerformance = allowedCookies.includes('performance');
            const includesPromotional = allowedCookies.includes('promotional');
            const domain = window.location.hostname;

            if (includesPerformance && includesPromotional) {
                return;
            }

            if (includesPerformance) {
                document.cookie = `u_eh=; max-age=0; domain=${domain}; path=/`;
                document.cookie = `_fbp=; max-age=0; domain=${domain}; path=/`;
                document.cookie = `_gcl_au=; max-age=0; domain=${domain}; path=/`;
                document.cookie = `_uetsid=; max-age=0; domain=${domain}; path=/`;
                document.cookie = `rv_id=; max-age=0; domain=${domain}; path=/`;
                document.cookie = `_uetvid=; max-age=0; domain=${domain}; path=/`;
                document.cookie = `MUID=; max-age=0; domain=${domain}; path=/`;
                document.cookie = `test_cookie=; max-age=0; domain=${domain}; path=/`;
                return;
            }
            
            if (includesPromotional) {
                document.cookie = `_ga_R613Q96C2Y=; max-age=0; domain=${domain}; path=/`;
                document.cookie = `QSI_S_ZN_86teTLpjbZZ8hz7=; max-age=0; domain=${domain}; path=/`;
                document.cookie = `_ga=; max-age=0; domain=${domain}; path=/`;
                return;
            }
        },

        loadMinimalFooter: function (countryCode, callback) {
            const host = Constants.CookieDomains[
                window.WebConstants.stage === 'prod' ? 'prod' : 'dev'
            ][countryCode];
        
            if (host) {
                let script = document.createElement('script');
        
                script.onload = function () {
                    let el = document.createElement("cms-global-footer");
                    document.querySelector("body").appendChild(el);
                    if (callback) callback(true);
                };
        
                script.onerror = function () {
                    if (callback) callback(false); 
                };
        
                script.src = `https://${host}/data/apps/metro?sc_device=webcomponent&components=global%20footer`;
                document.head.appendChild(script);
            } else {
                if (callback) callback(false); 
            }
        },

        getRequestedPageName(page, userType, initSessionId, loginMethod) {
            var value = window.location.href.toLowerCase();
            if (window.WebConstants && window.WebConstants.errorStatusCode) {
                return require('../components/Errors/' + Constants.StatusComponents[window.WebConstants.errorStatusCode]);
            }
            else if (value.includes('forgot-password')) {
                return require('../components/ForgotPassword/ForgotPassword');
            }
            else if (value.includes('validate-otp')) {
                return require('../components/ValidateOtp/ValidateOtp');
            }
            else if (value.includes('/reset-password-page')) {
                return require('../components/ResetPassword/ResetPassword');
            }
            else if (value.includes('/change-password')) {
                return require('../components/ChangePassword/ChangePassword');
            }
            else if (value.includes('/signedout')) {
                return require('../components/SignedOut/SignedOut');
            }
            else if (value.includes('/loginpreferences')) {
                return require('../components/LoginPreferences/LoginPreferences');
            }
            else if (value.includes('/setloginpreferences')) {
                return require('../components/LoginPreferences/SetLoginPreferences');
            }
            else if (value.includes('/login-prefs')) {
                return require('../components/LoginPreferences/LoginPrefs');
            }
            else if (value.includes('/loginprefsredirect')) {

                return require('../components/LoginPreferences/LoginPrefSilentAuth');
            }
            else if (value.includes('/handleauth')) {
                return require('../components/LoginPreferences/LoginPreferencesHandleAuth');
            }
            else if (value.includes(Constants.Links.SIGN_IN_PAGE.toLowerCase()) || value.includes(Constants.Links.SAML_SIGN_IN_PAGE.toLowerCase())) {
                let comp = {};
                if (!page) {
                    if (initSessionId.match(/^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i) && loginMethod === "WEB_AUTHN") {
                        comp = require('../components/Webauthn1FaLoginPage/Webauthn1FaLoginPage');
                    }
                    else {
                        switch (userType) {
                            case Constants.UserTypes.CUST:
                                comp = require('../components/CustomerLoginPage/CustomerLoginPage');
                                break;
                            case Constants.UserTypes.EMP:
                                comp = require('../components/EmployeeLoginPage/EmployeeLoginPage')
                                break;
                            case Constants.UserTypes.FUNC:
                                comp = require('../components/FunctionalUserLoginPage/FuncUserLoginPage')
                                break;
                            case Constants.UserTypes.SUPP:
                                comp = require('../components/SupplierLoginPage/SupplierLoginPage')
                                break;
                            case Constants.UserTypes.DEV:
                                comp = require('../components/DeveloperLoginPage/DeveloperLoginPage')
                                break;
                        }
                    }
                    return comp;
                }
            }
            else if (value.includes(Constants.Links.LINK_ACCOUNT)) {
                return require('../components/LoginPreferences/LinkAccount');
            }
            else if (value.includes(Constants.Links.CONSENT)) {
                return require('../components/LoginPreferences/Consent');
            }
        },

        getRequestedSource() {
            var value = window.location.href.toLowerCase();
            if (value.includes('forgot-password')) {
                return "ForgotPassword";
            }
            if (value.includes('validate-otp')) {
                return "ValidateOtp";
            }
            else if (value.includes('/reset-password-page')) {
                return "ResetPassword";
            }
            else if (value.includes('/change-password')) {
                return "ChangePassword";
            }
            else if (value.includes('/signedout')) {
                return "SignedOut";
            }
            else if (value.includes('/forbidden')) {
                return "Forbidden";
            }
            else if (value.includes(Constants.Links.SIGN_IN_PAGE.toLowerCase())) {
                return Constants.Links.SIGN_IN_PAGE;
            }
            else if (value.includes(Constants.Links.LINK_ACCOUNT)) {
                return Constants.Links.LINK_ACCOUNT
            }
            else if (value.includes(Constants.Links.CONSENT)) {
                return Constants.Links.CONSENT
            }
        },

        setTitleKey(clientId, intl) {
            const source = this.getRequestedSource();
            let title = '';
            switch (source) {
                case Constants.Links.SIGN_IN_PAGE:
                    title = LocaleUtils.formatMessage(
                        intl,
                        defaultMessages,
                        clientId.toLowerCase(),
                        intl.messages[clientId.toUpperCase()] || clientId.toUpperCase()
                    );
                    break;
                case Constants.Links.LINK_ACCOUNT:
                    title = "LinkAccounts";
                    break;
                case Constants.Links.CONSENT:
                    title = "Consent";
                    break;
                case "ChangePassword":
                    title = intl.formatMessage(defaultMessages['Change Password']);
                    break;
                case "ForgotPassword":
                    title = intl.formatMessage(defaultMessages['forgotYourPassword']);
                    break;
                case "ValidateOtp":
                    title = intl.formatMessage(defaultMessages['validateOtp']);
                    break;
                case "ResetPassword":
                    title = intl.formatMessage(defaultMessages['chooseANewPassword'])
                    break;
                case "SignedOut":
                    title = intl.formatMessage(defaultMessages['sign.out'])
                    break;
                case "Forbidden":
                    title = intl.formatMessage(defaultMessages['forbidden'])
                    break;
            }

            document.title = title == '' ? intl.formatMessage(defaultMessages['login']) : title;

        },

        tryParseJSON(jsonString) {
            try {
                var o = JSON.parse(jsonString);

                // Handle non-exception-throwing cases:
                // Neither JSON.parse(false) or JSON.parse(1234) throw errors, hence the type-checking,
                // but... JSON.parse(null) returns null, and typeof null === "object",
                // so we must check for that, too. Thankfully, null is falsey, so this suffices:
                if (o && typeof o === "object") {
                    return o;
                }
            }
            catch (e) { }

            return false;
        },

        tryParseToken(token) {
            try {
                var parsedToken = decodeJwt(token);
                return parsedToken
            }
            catch (e) { }
            return false;
        },

        replaceAllByKeys(str, mapObj) {
            if (_.isEmpty(mapObj))
                return str;
            var re = new RegExp(Object.keys(mapObj).join("|"), "gi");
            return str.replace(re, function (matched) {
                return mapObj[matched];
            }).replace('<', '').replace('>', '');;
        },

        mapToKeyValue(object) {
            let out = {};
            _.forEach(object, function (obj) {
                out[obj.key.trim()] = obj.value;
            });

            return out;
        },

        getvalueCount(obj) {
            if (_.isEmpty(obj))
                return 0;

            let count = 0;
            Object.keys(obj).forEach(key => {
                if (!_.isEmpty(obj[key]))
                    //use key and value here
                    count++;
            });

            return count;
        },

        removeEmptyValues(obj, keys) {
            const newObj = Object.assign({}, obj);

            Object.keys(newObj).forEach(key => {
                if (!keys &&  _.isEmpty(newObj[key])) {
                    delete newObj[key];
                } else if (keys && keys.includes(key) && _.isEmpty(newObj[key])) {
                    delete newObj[key];
                }
            });

            return newObj;
        },

        cookieExists(cookieName) {
            return document.cookie.split('; ').some(cookie => cookie.startsWith(cookieName + '='));
        },

        setUEHCookie(value){
            if(!this.cookieExists("allowedCookieCategories")){
                return
            }

            let allowedCookies = Cookies.get('allowedCookieCategories') || "performance|promotional";
            const domain = window.location.hostname;
            if(allowedCookies.includes('promotional')){
                const encodeToSHA256 = async (initialValue) => {
                    const msgBuffer = new TextEncoder().encode(initialValue);
                    const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer);
                    const hashArray = Array.from(new Uint8Array(hashBuffer));
                    const hashHex = hashArray.map(byte => byte.toString(16).padStart(2, '0')).join('');
                    return hashHex;
                };

                (async () => {
                    const encodedHash = await encodeToSHA256(value);
                    const daysToExpire = 365;
                    const maxAge = daysToExpire * 24 * 60 * 60;
                    document.cookie = `u_eh=${encodedHash}; max-age=${maxAge}; domain=${domain}; path=/`;
                })();
            }else{
                document.cookie = `u_eh=; max-age=0; domain=${domain}; path=/`;
                return
            }
        },

        googleAnalyticsClickEvents(event, category, country, pageView, userType, reamlId, clientId, loggenIn, passwordless = false, errorsObj={}){
            let allowedCookies = Cookies.get('allowedCookieCategories') || "performance";
            if (allowedCookies.includes('performance')) {
            
                country = Constants.GAFieldsValues.supportedCountries.includes(country) ? country : '';
                const errorPage = pageView == Constants.GAFieldsValues.pageViewType.error || false;
                const pageFields = this.getPageFields(pageView, country, userType, reamlId, clientId, loggenIn);
                const statusCode = window.WebConstants && window.WebConstants.errorStatusCode || '';

                const tagManagerArgs = {
                    dataLayer: {
                        [Constants.GAFields.event]: event,
                        [Constants.GAFields.category]: category,
                        [Constants.GAFields.cutomerTier]: Constants.GAFieldsValues.anonymous,
                        [Constants.GAFields.country]: country,
                        [Constants.GAFields.errorPage]: errorPage ? Constants.GAFieldsValues.errorpage : Constants.GAFieldsValues.noerror,
                        [Constants.GAFields.loggedIn]: Constants.GAFieldsValues.notloggedin,
                        [Constants.GAFields.pageName]: pageFields.pageName || '',
                        [Constants.GAFields.pageTitle]: pageFields.pageTitle || '',
                        [Constants.GAFields.salesLine]: _.includes(Constants.GAFieldsValues.makroCountries, country)
                                ? Constants.GAFieldsValues.salesLine_makro : Constants.GAFieldsValues.salesLine_metro,
                        [Constants.GAFields.solution]: Constants.GAFieldsValues.solution,
                        [Constants.GAFields.statusCode]: statusCode || Constants.GAFieldsValues.none,
                        [Constants.GAFields.userType]: pageFields.userType || '',
                        [Constants.GAFields.templateType]: pageFields.templateType || '',
                    },
                }

                if(event === "errors"){
                    delete tagManagerArgs.dataLayer[Constants.GAFields.category];
                    const newDataLayer = {
                        ...tagManagerArgs.dataLayer,
                        [Constants.GAFields.type]: errorsObj.type || '',
                        [Constants.GAFields.label]: errorsObj.label || '',
                    }
                    window.dataLayer.push(newDataLayer);
                    return
                }

                if(userType === 'CUST' && passwordless){
                    const newDataLayer = {
                        ...tagManagerArgs.dataLayer,
                        [Constants.GAFields.type]: 'autologin',
                    }
                    window.dataLayer.push(newDataLayer);
                    return
                }

                if((userType === 'CUST' || userType === 'SUPP' || userType === 'EMP') && !passwordless){
                    const newDataLayer = {
                        ...tagManagerArgs.dataLayer,
                        [Constants.GAFields.type]: 'login',
                    }
                    window.dataLayer.push(newDataLayer);
                    return
                }

                window.dataLayer.push(tagManagerArgs.dataLayer);
            }
        },

        setCaretPosition(elemId, caretPos) {
            var elem = document.getElementById(elemId);
            if (elem != null) {
                if (elem.createTextRange) {
                    var range = elem.createTextRange();
                    range.move('character', caretPos);
                    range.select();
                }
                else {
                    if (elem.selectionStart) {
                        elem.focus();
                        elem.setSelectionRange(caretPos, caretPos);
                    }
                    else
                        elem.focus();
                }
            }
        },

        getPageView() {
            var value = window.location.href.toLowerCase();
            if (window.WebConstants && window.WebConstants.errorStatusCode) {
                return Constants.GAFieldsValues.pageViewType.error;
            }
            else if (value.includes('forgot-password')) {
                return Constants.GAFieldsValues.pageViewType.forgotPassword;
            }
            else if (value.includes('/reset-password-page')) {
                return Constants.GAFieldsValues.pageViewType.resetPassword;
            }
            else if (value.includes('/change-password')) {
                return Constants.GAFieldsValues.pageViewType.changePassword;
            }
            else if (value.includes('/signedout')) {
                return Constants.GAFieldsValues.pageViewType.signOut;
            }
            else if (value.includes('/loginpreferences')) {
                return Constants.GAFieldsValues.pageViewType.setLoginpreferences
            }
            else if (value.includes('/login-prefs')) {
                return Constants.GAFieldsValues.pageViewType.updateLoginpreferences
            }
            else if (value.includes(Constants.Links.SIGN_IN_PAGE.toLowerCase())) {
                return Constants.GAFieldsValues.pageViewType.login;
            }
            else if (value.includes(Constants.Links.LINK_ACCOUNT)) {
                return Constants.GAFieldsValues.pageViewType.linkAccount
            }
            else if (value.includes(Constants.Links.CONSENT)) {
                return Constants.GAFieldsValues.pageViewType.consent
            }
        },

        setGADatalayer(country, languageSelected, userType, reamlId, clientId, redirectUrl, loggenIn = false) {
            let allowedCookies = Cookies.get('allowedCookieCategories') || "performance";
            if (allowedCookies.includes('performance')) {
                const pageView = this.getPageView();
                const errorPage = pageView == Constants.GAFieldsValues.pageViewType.error || false;
                const statusCode = window.WebConstants && window.WebConstants.errorStatusCode || '';
                country = country != Constants.DEFAULT_COUNTRY_CODE ? country : this.getTld(redirectUrl);

                var pageFields = this.getPageFields(pageView, country, userType, reamlId, clientId, loggenIn);

                const tagManagerArgs = {
                    dataLayer: {
                        'event': 'page.impression',
                        [Constants.GAFields.solution]: Constants.GAFieldsValues.solution,
                        [Constants.GAFields.salesLine]: _.includes(Constants.GAFieldsValues.makroCountries, country)
                            ? Constants.GAFieldsValues.salesLine_makro : Constants.GAFieldsValues.salesLine_metro,
                        [Constants.GAFields.country]: country,
                        [Constants.GAFields.languageSelected]: languageSelected || Constants.LOCALE_EN_GB,
                        [Constants.GAFields.pageName]: pageFields.pageName,
                        [Constants.GAFields.pageTitle]: pageFields.pageTitle,
                        [Constants.GAFields.userType]: pageFields.userType,
                        [Constants.GAFields.templateType]: pageFields.templateType,
                        [Constants.GAFields.userInterface]: Constants.GAFieldsValues.responsivesite,
                        [Constants.GAFields.statusCode]: statusCode || Constants.GAFieldsValues.none,
                        [Constants.GAFields.loggedIn]: loggenIn ? Constants.GAFieldsValues.loggedin : Constants.GAFieldsValues.notloggedin,
                        [Constants.GAFields.errorPage]: errorPage ? Constants.GAFieldsValues.errorpage : Constants.GAFieldsValues.noerror,
                        [Constants.GAFields.storeId]: Constants.GAFieldsValues.unknown,
                        [Constants.GAFields.storeName]: Constants.GAFieldsValues.unknown,
                        [Constants.GAFields.breadcrumb]: Constants.GAFieldsValues.nobreadcrumb,

                    },
                }
                console.log(tagManagerArgs);
                TagManager.dataLayer(tagManagerArgs);
            }
        },

        setGASocialLoginDataLayerEvent(action, label) {
            try {
                const tagManagerArgs = {
                    dataLayer: {
                        'event': 'manual.event',
                        'eventCategory': 'alternative_login',
                        'eventAction': action,
                        'eventLabel': label,
                    },
                }

                TagManager.dataLayer(tagManagerArgs);
            }
            catch (err) {
                console.log("There was a problem with GA Events")
            }
        },

        parseDomainURL(url) {
            if (!url) {
                console.log('URL is empty');
                return { 
                    tld: "",
                    domain: "",
                    subdomain: ""
                };
            }

            const urlPattern = /^(?:https?:\/\/)?(?:www\.)?([^:\/?\n]+)(?:[\/?\#].*)?$/i;
            const matches = url.match(urlPattern);

            if (!matches) {
                console.log('Invalid URL');
                return { 
                    tld: "",
                    domain: "",
                    subdomain: ""
                };
            }

            const domainParts = matches[1].split('.');
            const tld = domainParts.pop();
            const domain = domainParts.pop();
            const subdomain = domainParts.join('.') || '';

            return {
                tld: tld,
                domain: domain,
                subdomain: subdomain
            };
        },

        getTld(redirectUrl) {
            var countryCode = null;
            var url = redirectUrl || window.location.host;
            const domain = this.parseDomainURL(url);

            if (domain && domain.tld && _.includes(Constants.GAFieldsValues.supportedCountries, domain.tld.toUpperCase()))
                countryCode = domain.tld.toUpperCase();
            else {
                var hostName = '';
                try {
                    var match = url.match(/^(https?\:)\/\/(([^:\/?#]*)(?:\:([0-9]+))?)([\/]{0,1}[^?#]*)(\?[^#]*|)(#.*|)$/);
                    var hostName = match && match[3];
                    if (hostName) {
                        const index = hostName.indexOf('.');
                        var country = index !== -1 ? hostName.substring(0, index) : '';

                        if (country && _.includes(Constants.GAFieldsValues.supportedCountries, country.toUpperCase()))
                            countryCode = country.toUpperCase();
                    }
                }
                catch (ex) {
                    console.log(ex);
                }
            }

            return countryCode || Constants.GAFieldsValues.hostnameCountryCodeMap[window.location.host.toLowerCase()] || Constants.GAFieldsValues.nocountry;
        },

        getPageFields(pageView, country, userType, reamlId, clientId, loggenIn) {
            var result = {};
            var pageNameArr = [];
            var userType = _.includes(Constants.GAFieldsValues.supportedUserTypes, userType) ? userType : '';
            var property = pageView + userType;

            //<pageTitle>|<country>|<solution>|<maincategory>|<siteSubcategory1-n>
            var pageObj = Constants.GAFieldsValues[property] ? Constants.GAFieldsValues[property] : {};
            pageNameArr["1"] = pageObj.pageTitle || null;
            pageNameArr["2"] = country.toUpperCase();
            pageNameArr["3"] = Constants.GAFieldsValues.solution;
            if (reamlId) {
                pageNameArr["4"] = reamlId.toLowerCase();
                if (clientId)
                    pageNameArr["5"] = clientId.toLowerCase();
            }
            pageNameArr["6"] = '';
            var nameValues = Object.keys(pageNameArr).map(function (itm) { return pageNameArr[itm]; });
            result.pageName = nameValues.join("|");

            //<pageTitle>|<templateType>
            var pageTitleArr = [];
            pageTitleArr["1"] = pageObj.pageTitle || null;
            pageTitleArr["2"] = pageObj.templateType || null;
            var titleValues = Object.keys(pageTitleArr).map(function (itm) { return pageTitleArr[itm]; });
            result.pageTitle = titleValues.join("|");

            result.templateType = pageObj.templateType;
            result.userType = loggenIn ? pageObj.userType : Constants.GAFieldsValues.anonymous;
            return result;
        },
        publicKeyCredentialToJSON: function (pubKeyCred) {
            if (pubKeyCred instanceof Array) {
                let arr = [];
                for (let i of pubKeyCred)
                    arr.push(Utils.publicKeyCredentialToJSON(i));

                return arr
            }

            if (pubKeyCred instanceof ArrayBuffer) {
                return base64url.encode(pubKeyCred)
            }

            if (pubKeyCred instanceof Object) {
                let obj = {};

                for (let key in pubKeyCred) {
                    obj[key] = Utils.publicKeyCredentialToJSON(pubKeyCred[key])
                }

                return obj
            }

            return pubKeyCred
        },
        getUrlFromEnvUrls: function (envUrl) {
            if (envUrl.includes("localhost")) {
                return envUrl;
            } else {
                const urlElement = document.createElement('a');
                urlElement.href = envUrl;
                var pathname = urlElement.pathname;

                if (pathname[0] != '/')
                    pathname = '/' + pathname;
                return window.location.origin + pathname;
            }
        },

        formIssuer: function (userType) {
            var result = {};
            var issuer = userType == Constants.UserTypes.SUPP ? Constants.Issuer.METRO_LINK_PLUS : Constants.Issuer.M_IDENTITY;
            var otpauth = userType == Constants.UserTypes.SUPP ? 'IDAM:' : 'M|Identity: ';
            var separator = userType == Constants.UserTypes.SUPP ? ':' : ' ';
            var stage = window.WebConstants.stage;
            var env = '';
            if (userType != Constants.UserTypes.SUPP && stage.toLowerCase() == 'prod') {
                env = '';
            }
            else {
                env = separator + stage.toUpperCase();
            }

            result.issuer = issuer + env;
            result.otpauth = 'otpauth://totp/' + otpauth;
            return result;
        },

        checkCodesViaSmsTOTPTimestamp() {
            const timestamp = localStorage.getItem("totp_sms_timestamp")

            // check if timestamp exist. If not, user can select codes via sms option
            if (timestamp === null) {
                return true
            }

            else {
                const currentTimestamp = new Date().getTime();
                const fifteenMinutes = 1000 * 60 * 15;

                return currentTimestamp - timestamp > fifteenMinutes
            }
        },

        setCodesViaSmsTOTPValidityTimestamp() {
            const date = new Date();
            const timestamp = Date.parse(date);

            localStorage.setItem("totp_sms_timestamp", timestamp);
        },

        debounce(func, wait = 500) {
            let timeout;
            return function executedFunction(...args) {
              const later = () => {
                clearTimeout(timeout);
                func(...args);
              };
          
              clearTimeout(timeout);
              timeout = setTimeout(later, wait);
            };
        },

        removeCodesViaSmsTOTPValidityTimestamp() {
            localStorage.removeItem("totp_sms_timestamp");
        },

        logoutRedirect() {
            Session.destroy('sessionLP');

            const idamClient = OAuthClientConfig;
            generateLogoutUrl(idamClient)
                .then((logoutUrl) => {
                    clearLocalStorage();
                    Session.destroy();
                    window.location = logoutUrl;
                });
        }
    };
    module.exports = Utils;

}());
